<template>
  <div class="bg-teal-50 rounded-lg px-3 py-2">
    <div class="flex gap-2 items-center">
      <PatchCheckIcon />
      <span class="text-sm text-gray-700">{{ infoText }}</span>
    </div>
    <slot> </slot>
  </div>
</template>
<script setup lang="ts">
import PatchCheckIcon from '@/public/icons/patch-check.svg?component'
const props = withDefaults(
  defineProps<{
    infoText: string
    tooltipText?: string
  }>(),
  {
    infoText: '',
    tooltipText: '',
  }
)
</script>
